import { Component } from "react";
import { CommonProps } from "../../components/web-components/common/common-props";

const withCommonEvents = <P, S>(WrappedComponent) => {
  class CommonEventComponent<P, S> extends Component<P & CommonProps, S> {
    // Cache for disabled style to avoid creating new objects on every render
    private cachedDisabledStyle: any = null;
    private lastStyleRef: any = null;

    constructor(props: any) {
      super(props);
    }

    handleClick = (e: any) => {
      if (this.props.onClick && typeof this.props.onClick === "function") {
        this.props.onClick(e, this.props.rowIndex);
      }
    };

    // Get or create disabled style (memoized)
    private getDisabledStyle = (originalStyle: any): any => {
      // Return cached style if the original style reference hasn't changed
      if (this.cachedDisabledStyle && this.lastStyleRef === originalStyle) {
        return this.cachedDisabledStyle;
      }

      this.lastStyleRef = originalStyle;
      this.cachedDisabledStyle = {
        ...originalStyle,
        pointerEvents: "none",
        opacity: 0.7
      };

      return this.cachedDisabledStyle;
    };

    render() {
      if (this.props.visibility === "hidden") {
        return <></>;
      }

      const isDisabled = this.props.editability === "disabled";
      const originalStyle = (this.props as any).style;

      // Only compute disabled style if needed and style exists
      const style = isDisabled && originalStyle ? this.getDisabledStyle(originalStyle) : originalStyle;

      return (
        <WrappedComponent<P & CommonProps, S>
          {...(this.props as P)}
          style={style}
          onClick={this.handleClick}
          ref={this.props.kuikaRef}
          tabIndex={isDisabled ? -1 : undefined}
        />
      );
    }
  }

  return CommonEventComponent;
};

export default withCommonEvents;
